const stylesInput = {
  label: {
    position: "absolute",
    left: "8px",
    transition: "all 0.3s ease",
    pointerEvents: "none",
    background: "white",
    padding: "0 4px",
  },
  div: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    border: "none",
    borderRadius: '10px',
    padding: "8px",
    backgroundColor: "transparent",
    color: "gray",
    borderColor: "none",
    outline: "none",
    marginTop: "1rem",
  },
};

export default stylesInput;
